/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as printJS from 'print-js';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/local-storage.service';
import { Page } from 'src/app/page';
import { Pageable } from 'src/app/pageable';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';
import { ToastrImplService } from './toastr.service';

@Injectable({
   providedIn: 'root',
})
export class CpsuSubjectService {
   constructor(private httpClient: HttpClient, private app: AppService, private localStorage: LocalStorageService, private toastr: ToastrImplService) {}
   getFilteredPage(body: any): Observable<Page<any>> {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });

      return this.httpClient.post(this.app.getCpsuUrl() + environment.getCpsuPaginationUrl, body, { headers }) as Observable<any>;
   }

   printPdf(body: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });

      this.httpClient.post(this.app.getCpsuUrl() + environment.exportPdfCpsuSubjectUrl, body, { responseType: 'blob', headers }).subscribe(data => {
         const file = new Blob([data], { type: 'application/pdf' });
         const fileURL = URL.createObjectURL(file);
         printJS(fileURL);
      });
   }

   exportCSV(body: any, filename) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });

      this.httpClient.post(this.app.getCpsuUrl() + environment.exportCsvCpsuSubjectUrl, body, { responseType: 'blob', headers }).subscribe(data => {
         const parts = [];
         parts.push('\uFEFF');
         parts.push(data);
         const file = new Blob(parts, { type: 'text/csv' });
         const fileURL = URL.createObjectURL(file);
         const a = document.createElement('a');
         document.body.appendChild(a);
         a.setAttribute('style', 'display: none');
         a.href = fileURL;
         a.download = filename + '.csv';
         a.click();
         window.URL.revokeObjectURL(fileURL);
         a.remove();
      });
   }

   getCurrentCpsuSubject(id: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      });
      return this.httpClient.get(this.app.getCpsuUrl() + environment.getCpsuSubjectUrl + id, { headers }) as Observable<any>;
   }

   getHistoryPage(pageable: Pageable, id: any): Observable<Page<Object>> {
      const headers = new HttpHeaders({
         'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      });
      return this.httpClient.get(this.app.getCpsuUrl() + environment.getCpsuSubjectHistory + id + '/' + pageable.pageNumber + '/' + pageable.pageSize, { headers }) as Observable<any>;
   }

   insertSubjectInCpsu(body: any): Observable<any> {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      return this.httpClient.post(this.app.getCpsuUrl() + environment.addCpsuSubjectUrl, body, { headers }) as Observable<any>;
   }

   addDossierOwner(cpsuSubjectId: any, ownerId: any, ownerFullName: string): Observable<any> {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      const body = {
         cpsuSubjectId: cpsuSubjectId,
         ownerId: ownerId,
         ownerFullName: ownerFullName,
      };
      return this.httpClient.put(this.app.getCpsuUrl() + environment.addDossierOwnerCpsuSubject, body, { headers }) as Observable<any>;
   }

   getExpeditionData(id: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      });
      return this.httpClient.get(this.app.getCpsuUrl() + environment.getExpeditionData + id, { headers }) as Observable<any>;
   }

   archiveSubject(id: string | number, archiveData: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      return this.httpClient.put(this.app.getCpsuUrl() + environment.archiveCpsuSubjectUrl + id, archiveData, { headers }) as Observable<any>;
   }

   unarchiveSubject(id: string | number, unarchiveData: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      return this.httpClient.put(this.app.getCpsuUrl() + environment.unarchiveCpsuSubjectUrl + id, unarchiveData, { headers }) as Observable<any>;
   }

   getCpsuFosterFamily(cpsuSubjectId: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      return this.httpClient.get(this.app.getCpsuUrl() + environment.getCpsuFosterFamily + cpsuSubjectId, { headers }) as Observable<any>;
   }

   findFosterParentsForCsrAndCpsu(cpsuId: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      });
      return this.httpClient.get(this.app.getCpsuUrl() + environment.findFosterParentsForCsrAndCpsu + cpsuId, { headers }) as Observable<any>;
   }

   findWhereSubjectExist(subjectId: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      });
      return this.httpClient.get(this.app.getCpsuUrl() + environment.findWhereSubjectExist + subjectId, { headers }) as Observable<any>;
   }

   connectFosterChildToFosterParent(body: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      return this.httpClient.put(this.app.getCpsuUrl() + environment.connectFosterChild, body, { headers }) as Observable<any>;
   }

   disconnectFosterChildFromFosterParent(subjectId: any) {
      const headers = new HttpHeaders({
         'Content-type': 'application/json',
      });
      return this.httpClient.put(this.app.getCpsuUrl() + environment.disconnectFosterChild + subjectId, { headers }) as Observable<any>;
   }
}
